module.exports = __webpack_public_path__ + "static/media/image1.7e99ba04.jpg";